import { Navigate, useNavigate } from "react-router";
import { DataFormat } from "utils/format/DataFormat";
import Main from "./Main";

function PrivateRoute({ children, ...rest }) {
  const token = DataFormat.getToken();
  const alterToken = DataFormat.getAlterToken();
  const navigate = useNavigate();

  if (!token && !alterToken) return <Navigate to="/login" />;

  return (
    <Main location={window.location} navigate={navigate}>
      {children}
    </Main>
  );
}

export default PrivateRoute;
